import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import EditDailyCheckInForm from '../EditDailyCheckInForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'
export default function EditDailyCheckInListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขกิจกรรมเช็คอินรายวัน`}
					description="แก้ไขกิจกรรมเช็คอินรายวัน"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<EditDailyCheckInForm />
		</div>
	)
}
